:host {
  display: block;
  padding: 0.5em 1em;
  padding-left: 0px;
}